<template>
  <div class="goods-address-page-wrap">
    <div class="page-content">
      <section class="plate-no-wrap">
        <div class="title">
          <span class="label">输入要办理ETC的牌号</span>
        </div>
        <div class="input-box">
            <span v-for="(v, i) in plateNos"
                  :class="{'point': i===2, 'eight': i===8, 'focus': (focusIndex===i && i!==2)}"
                  :key="i"
                  @click="tapPlateInput(i)">{{v}}</span>
        </div>
        <p class="tip">请正确填写车牌信息，提交后不能更改</p>
      </section>
      <section class="plate-type-wrap">
        <div class="title">
          <span class="label">选择车牌类型</span>
        </div>
        <div class="plate-types">
          <div class="plate-type" @click="tapPlateColor('蓝色')">
            <img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAANIAAABOCAMAAABi47hIAAAAk1BMVEUAAAAAle4AlO4AlO8AlO8AlPMAqv8AlO8AlO7////M6ftLs/M4q/GY1PgJmO4doPDS7PwrpvH0+v7H5/tov/XZ7/zX7vyl2fl3xvad1vjm9P1wwvW64voTnO+GzPc9rfIyqfElo/BivfRcuvTr9v3e8fxWuPP6/f6AyvaOz/dFsfKr3Pnj8/3C5ftvwvVPtfO14Prposs+AAAACHRSTlMA89WUjysGveasGXIAAALhSURBVHja7dtbb7IwAMZx5tz2PEzKQZ0ncII4PO3w/T/dC6U4RmbyXnTGNv4uCrqb/kPaLBt1Kg/93h2Md9frPzi1x3tY4/5RFj3BIk9Vk0XPqHJfriNY5sHpwzJ9pwfL9BwLdu+f7hxYx/KkZzdyn2Gc7rSd1o9YMa6pO+12ksuKC8N0p91OiliJYJjOtG1/ShauJQt3PFvckkxwSzLBLckEt6T/kkynUKbTBB1+ePrq4PnQ7W+SUlJAEmSKb9sqwWMT/MpIQDfdSSNpS37Udx/ktr5DZcxBO2nHGfTSnyR4lgDaSeuXUsT5i+RDF/1JnjQhZ/XdjJzUd52kBduuOEk6s5a6SbskSSbMynFjQJLvuk1SEDTT7SZtAcz4Vo4mJGH1GcrrYhtCMTfJ/9zLqS7lh4JvaBtzHYYH7kKxYLxYLIaclWN+3UlvDFSSvBTZupaoJCU1aHtoJ6UFT/YqaaN27QW/siwLuCtHc55SEvA4aYSntSSptRQwvf619J0k3lmsgB+z7SZFFCYlHcgRMC28BCdHrtAkLYVIeRQlY5KyYlp9zpmP0MgZyqtRvz201lKKSjIj3WbKUb09HID1eDzekJuxdNVJIklU0sl+M4HCmgvJk/n6OfhzQqibhFyF4ahOEh7nPmbRB/TSn+QPf+FDCpmX4zPdajxyPgAmnEIv/UkhfxFC2jNAk7QvdglMScpXq9WnHAfka3k57XMZv1AnHYIgDyoR59VlCY30J83LMZUjSFGO8yZpyaVKCvjTBJpcOumda5W0elVietUlhSaXTooYqqSaMWvpbNKg+tK0pCyOhyziOH6XY0xWY8FhHGfqb1ymJS151hLIuQdMS/IHZ/nAuk4JvVaFNx9BNweXI3ABt/9cmOGWZIJbkgksTzLztajOrC14ea07awteMezO2oIXQbuztv0pWbiWLNzxbGFjkoWHfSw8kmXhwTkLjzdaeAjVxqPCFh7otu7Y/T+bhCUYao8gJgAAAABJRU5ErkJggg==" alt="">
            <i v-show="choosedPlateColor==='蓝色'" color-blue class="iconfont etc-icon-check"></i>
          </div>
          <div class="plate-type" @click="tapPlateColor('渐变绿色')">
            <img src="data:image/png;base64,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" alt="">
            <i v-show="choosedPlateColor==='渐变绿色'" color-green class="iconfont etc-icon-check"></i>
          </div>
          <!-- <div class="plate-type" @click="tapPlateColor('其他')">
            <img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAANIAAABOCAMAAABi47hIAAAAZlBMVEUAAADd3d3d3d3e3t7d3d3h4eH////d3d3d3d2ZmZnIyMioqKitra3a2tq1tbXS0tLFxcXV1dWcnJyfn5+xsbGioqLPz8+/v7+5ubnBwcGvr6/MzMylpaWrq6u3t7fX19e8vLyqqqpaR8P8AAAACHRSTlMA89WUjysGveasGXIAAAQ4SURBVHja7NTJDcAgDERRsxgGfKP/YiMnJ9OBR3kVzBfC4rTXgvRK7Sqf0UCjjbdogsj0JqI3ck1EQUalg0yXCjJVCK53VAR0yJO2HdtIJ84OSXu5dE3X7JBkyxmSuWaHpLPcQTLXbPZXIvxLhBePxZ+UwcNuvew4CgNRGN7WwWWb2LEJEG7v/5JDFxfjSGnNYoampfyLREgm4kuBkw/pN/Qh/YY+JEkzs84PDumuoLUHc0svDbK4Zq5lsaXvs207UN7/IN0AJBKAGx0q0x8uBZSU1XYQigEMzVUI24posjRJHVDQS/+Y1M6VAIp2rQBQtnO0NgHmLSkCXieS9nDbEGpk6cGY8QySxts0SRaALUJoNlLeHagS6QGM9IZ0A8I1SD2g5OY7kGydbloHrxeSHIR0B1s7AdX2SmeRqJljANxIhwOStAfKjNT2AYH26jGmKQ11dr0sXwGL4hvSydtDDXh9ICkPYCUpvEldmTR4oKeFpEvh/CVJxxgnYJTXKkZ7OsmHNZ+RGgCVkHy3ezZS55ccvnJ+r5NtJa87mZSXSAWEZO9pAPVQAE86VHh4Brwp9lFfgqSmNXUgDV5IBkveybORk2wDuLgscV112z+UmR3QMXtAMY/XeJYaCEne3COS2kiK1uIdQLBkAO69TKPUh0E5utb2oAF4IQVRJNK0nDc+Mcfb75IuleCNJWkEmkQamqY/lfTc20hCGO9AFXX5QuI0xCBXaJwzMjX+Mi3nDwGoE2lJ/fD2UP1hz+52VYWBMAyfflMZWqD8lCqw7/8mN0xLqIKJB2SxVuJzZhMNb2rKKH0ceJ6SHJFdJ4e6ZSxGrUeIJg6y4JvEbUnFMLUTEXns/NwujbxPanxGNEAYg8jKWtBAaJk7kiSOh/3FPy72SZZmDi/qgzVdh8q+LFVya57w7PokQ0QZRLah5aDeQIyIVJYtIY0xRmnsnJtk8pklIpuL5IU5TuLHYPiDKT7VEvU4dn7SQG/lx0mh5pOkNlvdiaps1SLxa5KK0noAzepOYmpW8a2HLFLnJ2kVOKuiQUV6n+S6Tlabp5GILcVjwzKCC5MinkrKIVqqOg2xT4rizTaSPbKhoFLYFHo1ED30qsDO6UnsaiIKB60uaXZ3vEuqsZmIcgQ+k/k8/KUy6xVDXHM8CB2mzX865JkHLeqW0yS/XGzrIlvKIth3NdH2hVPySVXuMRvVxs7RajMicXoSh4LKJY1dJVGcJHFJLxrAx8W7QlRYEpUHFL2lsDk/CW65esdIcSfbkCTBvTT1mMkWZQoJLVE1X5kEe1PYKfIbnpKgXTesutZjMZW9G/FidDdSstlvaXxOks5VyIh9jHGswGm+Ty7+im/SX/BN+t++HRQBAMAgDPPvejZGrjjg3ywMv+RlUWC8BiaGhaBfVgg6sULQxYnYByRZIJwDeSOIUEUqDIJujt0faEMuZbmxazAAAAAASUVORK5CYII=" alt="">
          </div> -->
        </div>
        <p class="tip">• 仅限<span color-blue>蓝牌</span>、<span color-primary>绿牌</span>且<span color-black>≤9座</span>的小型汽车申办（<span></span>货车请进入ETC助手微信小程序办理）</p>
      </section>
      <section class="address-wrap">
        <div class="address-form">
          <ul class="form-list">
            <li class="form-item input" v-if="appChannel === 'zhaohang'">
              <label for="send_name">推荐人</label>
              <input type="text"
                     id="referrer_code"
                     maxlength="16"
                     placeholder="仅限数字和字母（选填）"
                     @input="referrerInput()"
                     @change="formChange('referrer_code')"
                     @click="clickI"
                     ref="input5"
                     @blur="blurI('input5')"
                     v-model="formData.referrer_code"
              >
            </li>
            <li class="form-item input">
              <label for="send_name">收货人</label>
              <input type="text"
                     id="send_name"
                     maxlength="20"
                     placeholder="姓名（必填）"
                     @change="formChange('send_name')"
                     @click="clickI"
                     ref="input1"
                     @blur="blurI('input1')"
                     v-model="formData.send_name"
              >
            </li>
            <li class="form-item input">
              <label for="send_phone">手机号码</label>
              <input type="tel"
                     id="send_phone"
                     maxlength="11"
                     placeholder="手机（将用于通行发票开具，不可修改）"
                     @input="phoneInput"
                     @change="formChange('send_phone')"
                     @click="clickI"
                     ref="input2"
                     @blur="blurI('input2')"
                     v-model="formData.send_phone">
              <phone-code
                @getCode="getCode"
                :countDownNum="countDownNum"
                :codeInvalid="phoneInvalid"
                initBtnText="验证手机"
                ref="phoneCode"
              ></phone-code>
            </li>
            <li v-show="isNeedPhoneVerify" class="form-item input">
              <label for="verification_code">短信验证</label>
              <input type="tel"
                     id="verification_code"
                     maxlength="4"
                     placeholder="短信验证（必填）"
                     @change="formChange('verification_code')"
                     @click="clickI"
                     ref="input3"
                     @blur="blurI('input3')"
                     v-model="formData.verification_code">
            </li>
            <li class="form-item">
              <label for="send_area">选择地区</label>
              <button id="send_area" class="value" :class="{'gray': !formData.send_area}" @click="choosePicker('send_area')">
                <span>{{formData.send_area || '地区信息（必填）'}}</span>
              </button>
            </li>
            <li no-border class="form-item">
              <label for="send_address">详细地址</label>
              <input
                name="send_address"
                id="send_address"
                maxlength="26"
                placeholder="街道门牌信息（最多25字）"
                @input="addressInput"
                @change="formChange('send_address')"
                @click="clickI"
                ref="input4"
                @blur="blurI('input4')"
                v-model="formData.send_address"/>
            </li>
          </ul>
          <div class="form-err-tip" color-red-tip v-show="formErrMsg || reqErrMsg">
            <i class="iconfont etc-icon-warn"></i>
            <span class="note">
                  <!--展示三种提示-->
                  {{formErrMsg || reqErrMsg}}
                </span>
          </div>
        </div>
      </section>
    </div>
    <div class="bottom-wrap">
      <div class="agreement-box" >
        <div class="check-wrap" @click="clickAgree">
        <i class="iconfont" :class="agreeProtocol?'etc-icon-checked':'etc-icon-uncheck'"></i>
        </div>
        <div class="agreement">
          <!--<span>查看</span>-->
          <span>已阅读同意</span>
          <span color-blue @click="goProtocol('USER_PRIVACY_PROTECTION_PROTOCOL')">隐私保护政策</span>
        </div>
      </div>
      <button cool-btn @click="submitAddress">下一步</button>
    </div>
    <plateNoBoard @keyBoardChange="keyBoardChangeEvent($event)" v-model="focusIndex"></plateNoBoard>
    <area-picker ref="picker" @confirmAreaPicker="confirmAreaPicker($event)"></area-picker>
    <popup  ref="codePopup">
      <div slot="content" class="toast-info-code">
        <div class="code-title">请输入图形验证码</div>
        <div class="code-input">
          <input class="input" v-model="imgCode" type="number" maxlength="4"/>
          <div class="code-r">
            <img :src="imgCodeSrc" @click="fleshImgCode" />
            <div class="tip">点击图片刷新</div>
          </div>
        </div>
        <div class="send-btn">
          <div class="img-code-btn" @click="submitImgCode">确认</div>
          <div class="cancel" @click="hideCodePopup">取消</div>
        </div>
      </div>
    </popup>
  </div>
</template>

<script>
// mixins
import FunMixin from '@/mixins/funMixin'
import BiMixin from '@/mixins/biMixin'
// store
import {mapState, mapMutations} from 'vuex'
// components
import PlateNoBoard from '@/components/etc.plateNoBoard'
import PhoneCode from '@/components/cool.phoneCode'
import AreaPicker from '@/components/cool.areaPicker'
import Popup from '@/components/cool.popup'

// config
import ETC from '@/config/etc.config'
import APP from '@/config/app.config'
// api
// import NewApplyApi from '@/api/newApply.api'
import reconApply from '@/api/reconApply.api'

import UserApi from '@/api/user.api'
// utils
import Plugins from '@/utils/plugins'
// json data
import PROVINCES from '../../assets/json/provinceCode'

const CHECK_FORM_FIELD = ['send_name', 'send_phone', 'send_area', 'send_address', 'verification_code']

let customData = {
  hasPhoneCode: 0,
  pickerIndex: {send_area: [0, 0, 0]},
  isIOS: ''
}

export default {
  name: 'goodsAddress',
  mixins: [FunMixin, BiMixin],
  components: {
    PlateNoBoard,
    PhoneCode,
    AreaPicker,
    Popup
  },
  data() {
    return {
      agreeProtocol: false,
      plateNos: ['', '', '', '', '', '', '', '', ''],
      focusIndex: null, // 车牌号键盘聚焦序号
      formData: {
        referrer_code: '',
        send_name: '',
        send_phone: '',
        send_area: '',
        send_address: '',
        verification_code: void 0
      },
      phoneInvalid: true,
      phoneCodeVer: 'no',
      countDownNum: 30,
      checkFormRule: '', // getCode : 校验手机号， allForm:校验所有
      formErrMsg: '',
      reqErrMsg: '',
      choosedPlateColor: '',
      cantChoosePlateC: false, // 通过数组前 8 位字符串长度判断是否填满前 7 位，若满了 7 位则为车牌号长度
      showImgCode: false,
      imgCodeSrc: '',
      imgCode: ''
    }
  },
  computed: {
    isNeedPhoneVerify() {
      /* if (customData.loginPhone) {
        this.formData.send_phone = customData.loginPhone
      } */
      // 如果手机号不需要校验
      if (this.phoneCodeVer !== 'no' && this.phoneCodeVer !== 'over_concurrency') return true
      if (APP.PHONE_REG.test(this.formData.send_phone) && (+this.formData.send_phone === +customData.loginPhone || +this.formData.send_phone === +customData.lastPhone)) return false
      return true
    },
    ...mapState(
      [
        'userApplyStep',
        'currentCard',
        'currentIssuer',
        'currentOrder',
        'newApplyInfo',
        'userLocation',
        'applyOrderInfo'
      ])
  },
  watch: {
    cantChoosePlateC: function(newV) {
      if (newV === 7) this.choosedPlateColor = '蓝色'
      if (newV === 8) this.choosedPlateColor = '渐变绿色'
    }
  },
  methods: {
    clickAgree() {
      this.agreeProtocol = !this.agreeProtocol
    },
    goProtocol(protocolName) {
      this.m_goPagesWithQ('agreement', {agreementType: protocolName, issuerId: ''})
    },
    referrerInput() {
      this.formData.referrer_code = this.formData.referrer_code.replace(/[^a-zA-Z0-9]/g, '')
    },
    blurI(name) {
      if (customData.isIOS) this.$refs[name].scrollIntoView(false)
    },
    clickI(e) {
      e.target.focus()
    },
    async tapPlateColor(c) {
      await this.m_clickDebounce('tapPlateColor')
      if (this.cantChoosePlateC) {
        this.m_showConfirm({content: `当前车牌号为${this.cantChoosePlateC - 2}位车牌号的${this.cantChoosePlateC === 7 ? '蓝' : '绿'}牌车`, noCancel: true})
        return
      }
      if (c === '其他') {
        this.m_showConfirm({content: '暂不支持此类车牌的车辆办理', noCancel: true})
        return
      }
      this.choosedPlateColor = c
    },
    async keyBoardChangeEvent(e) {
      if (e.type === 'tapKey') {
        this.plateNos[this.focusIndex] = e.val
        this.cantChoosePlateC = this.plateNos.slice(0, 8).join('').length >= 7 && this.plateNos.join('').length
        this.$forceUpdate()
        if (this.focusIndex === 8) return
        this.focusIndex++
        if (this.focusIndex === 2) this.focusIndex++
      } else if (e.type === 'confirmKey') {
        // if (this.plateNos.join('').length >= 7) {
        //   await NewApplyApi.checkPlateNo({plate_no: this.plateNos.join('')})
        // }
        this.focusIndex = null
      } else if (e.type === 'deleteKey') {
        this.plateNos[this.focusIndex] = ''
        this.cantChoosePlateC = this.plateNos.slice(0, 8).join('').length >= 7 && this.plateNos.join('').length
        this.$forceUpdate()
        if (this.focusIndex === 0) return
        this.focusIndex--
        if (this.focusIndex === 2) this.focusIndex--
      }
    },
    // 选择车牌输入框
    async tapPlateInput(i) {
      await this.m_clickDebounce('tapPlateInput')
      if (i === 2) return
      this.focusIndex = i
    },
    async confirmAreaPicker(e) {
      this.formData[e.key] = e.value
      customData.pickerIndex[e.key] = e.index
      this.$forceUpdate()
      this.checkForm()
    },
    choosePicker(key) {
      this.$refs.picker.$emit('showAreaPicker', {key, index: customData.pickerIndex[key]})
    },
    addressInput() {
      this.formData.send_address = this.formData.send_address.replace(APP.FILTER_ADDRESS_REG, ($1) => '')
    },
    phoneInput() {
      this.phoneInvalid = !APP.PHONE_REG.test(this.formData.send_phone)
    },
    formChange(key) {
      this.formData[key] = this.formData[key].trim()
      if (key === 'send_phone') this.formData = { ...this.formData, send_phone: this.formData.send_phone }
      this.checkForm()
    },
    getCode(p) {
      console.log(p)
      if (this.checkFormRule !== 'allForm') this.checkFormRule = 'getCode'
      this.checkForm()
      if (p === 'codeDisable') {
        return
      }
      if (p === 'getCode') {
        if (customData.hasPhoneCode !== 2) {
          this.biLog({eventID: 2001202, eventTypeID: 3})
          customData.hasPhoneCode = 2
          const phone = this.formData.send_phone
          reconApply.sendVerificationCodeNew({
            send_phone: phone,
            scene: 'apply_addr',
            check_code: this.imgCode || ''
          })
            .then(res => {
              this.imgCode = ''
              console.log(res);
              if (res.code === 200042) {
                this.m_showLoading()
                this.getImgCode()
                // 获取验证码超过三次 需要图形验证码
              } else {
                this.phoneCodeVer = res.verification_code
                this.m_showToast({msg: '验证码已发送', class: 'no-mask'})
                this.$refs.phoneCode.$emit('getCodeSuccess', {btnTextFmt: 'nums后重新获取'})
                this.$refs.codePopup.$emit('hidePopup')
              }
            }).catch(res => {
              this.$refs.phoneCode.$emit('cancelCountDown')
              if (res.msg) this.m_showToast(res.msg)
            }).finally(() => {
              customData.hasPhoneCode = 1
            })
        }
      }
    },
    fleshImgCode() {
      this.m_showLoading('验证码刷新中')
      this.getImgCode()
    },
    // 获取图形验证码
    getImgCode() {
      const phone = this.formData.send_phone
      reconApply.getImgCheckCode({
        phone,
        scene: 'apply_addr'
      })
        .then(res => {
          console.log(3233)
          this.$refs.codePopup.$emit('showPopup')

          this.imgCodeSrc = res.url
          this.imgCode = ''
          this.m_loadingClose()
        })
    },
    hideCodePopup() {
      this.imgCode = ''
      this.$refs.codePopup.$emit('hidePopup')
    },
    submitImgCode() {
      if (!this.imgCode || this.imgCode.length < 4) return this.m_showToast({class: 'no-mask', msg: '请输入图形验证码', timeout: 1000})
      this.getCode('getCode')
    },
    checkForm() {
      // 判断表单是否都填满
      if (this.checkFormRule !== 'allForm') {
        let isAll = true
        for (let i in CHECK_FORM_FIELD) {
          let k = CHECK_FORM_FIELD[i]
          if (!this.formData[k]) {
            isAll = false
            break
          }
        }
        if (isAll) this.checkFormRule = 'allForm'
      }
      if (this.checkFormRule === '') return
      let result = true
      let msg = ''
      const formData = Object.assign({}, this.formData)
      // formData.send_phone = formData.send_phone.replace(/ /g, '')
      formData.send_address = formData.send_address.replace(/\s/g, '')
      if (this.checkFormRule === 'getCode') {
        if (!formData.send_phone) {
          msg = '请输入手机号码'
          result = false
        } else if (!APP.PHONE_REG.test(formData.send_phone)) {
          msg = '手机格式不正确，请重填'
          result = false
        }
      } else {
        if (!formData.send_name) {
          msg = '请输入收货人姓名'
          result = false
        } else if (!APP.NAME_REG.test(formData.send_name)) {
          msg = '收货人姓名格式不正确，请重填'
          result = false
        } else if (!formData.send_phone) {
          msg = '请输入手机号码'
          result = false
        } else if (!APP.PHONE_REG.test(formData.send_phone)) {
          msg = '手机格式不正确，请重填'
          result = false
        } else if (!formData.send_area) {
          msg = '请选择地区'
          result = false
        } else if (!formData.send_address) {
          msg = '请输入详细地址'
          result = false
        } else if (!APP.ADDRESS_REG.test(formData.send_address)) {
          msg = '详细地址格式不正确，请重填'
          result = false
        } else if (this.isNeedPhoneVerify) {
          if (this.isNeedPhoneVerify && !formData.verification_code) msg = '请输入短信验证码'
          if (this.isNeedPhoneVerify && !/^\d{4}$/.test(formData.verification_code)) msg = '短信验证码格式不正确，请重填'
          if (this.phoneCodeVer === 'no' && customData.hasPhoneCode === 0) msg = '请先获取验证码'
          if (customData.hasPhoneCode === 2) msg = '验证码获取中'
          result = false
        } else {
          // const phone = formData.send_phone
          // if (customData.phoneCode && (customData.phoneCode !== formData.verification_code || customData.phone !== phone)) {
          //   msg = '短信验证码错误'
          //   result = false
          // }
        }
      }
      this.formErrMsg = msg
      return result
    },
    async submitAddress() {
      if (!this.checkCanApply()) return
      const plateNo = this.plateNos.join('')
      let msg = ''
      if (!plateNo) {
        msg = '请输入车牌号'
      }
      if (!this.choosedPlateColor) {
        msg = '请选择车牌颜色'
      }
      if ((this.plateNos[8] && plateNo.length < 8) || (!this.plateNos[8] && plateNo.length < 7)) {
        msg = '请补充完整车牌号'
      }
      if ((plateNo.length === 7 && this.choosedPlateColor === '渐变绿色') || (plateNo.length === 8 && this.choosedPlateColor === '蓝色')) {
        msg = '输入的车牌与车牌类型不匹配'
      }
      if (msg) {
        this.m_showConfirm({content: msg, noCancel: true})
        return
      }
      this.checkFormRule = 'allForm'
      this.checkForm()
      if (this.formErrMsg) return
      if (!this.agreeProtocol) {
        this.m_showToast('请同意隐私保护政策后继续')
        return
      }
      const plateColor = ETC.PLATE_COLOR[this.choosedPlateColor]
      let userS
      if (this.appChannel === 'pingankoudai' && (this.userApplyStep === null || localStorage.getItem(ETC.LOCAL_STORAGE_KEY.HOME_RELOAD) === 'yes')) {
        userS = await this.getUserOrderInfo('click')
        if (userS) return
      }
      this.m_showLoading()
      try {
        // if (this.appChannel !== 'zhaohang') await this.changeProvince(this.formData.send_area.split(' ')[0])
        let send_address = this.formData.send_address.replace(/\s/g, '')
        let send_province = (this.formData.send_area && this.formData.send_area.split(' ')[0]) || ''
        const plateInfo = {
          plate_no: plateNo,
          plate_color: plateColor
        }
        let params = Object.assign({}, this.formData, {
          order_type: this.appChannel === 'zhaohang' ? 4 : 6,
          free_type: 4,
          send_address,
          send_province,
          card_type: this.currentCard.card_type,
          card_id: this.appChannel === 'zhaohang' ? 27 : this.currentCard.id,
          // 需要上一步储存车牌号 或者从订单获取
          // plate_no: plateNo,
          // plate_color: plateColor,
          longitude: this.userLocation.longitude || '',
          latitude: this.userLocation.latitude || ''
        })

        if (!params.verification_code) {
          params.verification_code = void 0
        }

        const plateRes = await reconApply.postApplySubmitPlate({
          ...plateInfo,
          vehicle_belong: 1,
          flow_type: 19
        })
        this.setApplyOrderInfo({
          ...plateInfo,
          send_province,
          card_id: plateRes.card.id || 0
        })
        const res = await reconApply.userSaveAddress(params)
        if (res) {
          console.log(res, 232279898789)

          // 储存需要在后面储存了
          // if (this.appChannel === 'zhaohang') await NewApplyApi.zhaohangReferrer({referrer_code: this.formData.referrer_code || '', order_sn: res.order.order_sn})
          let applyInfo = Object.assign({}, this.formData, {
            plate_no: plateNo,
            plate_color: plateColor,
            plateNos: this.plateNos
          })
          applyInfo.verification_code = void 0
          this.setNewApplyInfo(applyInfo)
          // this.setCurrentOrder({order_sn: res.order.order_sn})
          if (this.appChannel === 'zhaohang') {
            console.log(79898789)
            await reconApply.orderSubmitOrder({
              ...this.applyOrderInfo,
              scene: 1,
              card_id: 27,
              purchase_type: 8,
              purchase_party: 6
            })
            this.$router.push('bindMM')
          } else {
            this.$router.push('goodsPay')
          }
        } else {
          this.reqErrMsg = res.msg
        }
      } catch (e) {
      } finally {
        this.m_loadingClose()
      }
    },
    // async changeProvince(p) {
    //   let params = {
    //     is_king: 0,
    //     send_province: p,
    //     issuer_province: this.currentIssuer.province || '',
    //     card_type: this.currentCard.card_type,
    //     order_sn: this.currentOrder.order_sn || '', // 用户可能有订单，但是删除了本地数据，导致没有跳转到对应页面
    //     card_id: this.currentCard.id,
    //     plate_no: this.plateNos.join(''),
    //     plate_color: this.choosedPlateColor,
    //     longitude: this.userLocation.longitude,
    //     latitude: this.userLocation.latitude
    //   }
    //   // freight_fee
    //   const {order, issuer, card} = await NewApplyApi.changeProvince(params)
    //   order && this.setCurrentOrder(order)
    //   issuer && this.setCurrentIssuer(issuer)
    //   card && this.setCurrentCard(card)
    // },
    async getLocation() {
      let pos
      // 5秒后没获取到定位就跳转
      let timer = setTimeout(() => {
        return Promise.resolve('end')
      }, 5000)
      try {
        pos = await Plugins.getLocation(this.appChannel)
        console.log('plugin get location success', pos)
        this.setUserLocation({latitude: pos.latitude, longitude: pos.longitude})
      } catch (e) {
        console.log('get location err', e)
      }
      clearTimeout(timer)
      return Promise.resolve('end')
    },
    async getUserOrderInfo(type) {
      console.log('goods address getUserOrderInfo type:', type, ' uid:', localStorage.getItem(ETC.LOCAL_STORAGE_KEY.UUID))
      try {
        const userInfo = await UserApi.getUserInfo()
        customData.paySuccessInfo = {
          orderSn: userInfo.apply_order_sn
        }
        // 有卡用户进入绑定成功页
        if (userInfo.has_card) { // 有卡
          this.$router.replace('activeSuccess')
          return 1
        }
        // 用户没卡
        if (userInfo.apply_order_sn) { // 有订单
          // 查询用户订单
          const {order, reject_reason, step_list} = await reconApply.getApplyCurrentOrder({order_sn: userInfo.apply_order_sn})
          // 保存发卡方，卡信息
          this.setCurrentIssuer(order.card_issuer)
          this.setCurrentCard(order.card)
          this.setCurrentOrder({reject_reason, ...order, step_list})
          customData.paySuccessInfo.plateNo = this.currentOrder.plate_no || ''
          // 付钱  上传  签约
          if (+order.prepay_status >= 3 && (Array.isArray(order.has_done) && !!~order.has_done.indexOf('SavePhotoInfo')) && !!~order.has_done.indexOf('SignEntrust')) {
            // 办理进度
            this.$router.replace('applyProgress')
            return 1
          }
          // 有订单 有选择办理方式进入办理结果页
          if (order.credit_card_bank) {
            location.href = ETC.PAKD_URL + `?uid=${localStorage.getItem(ETC.LOCAL_STORAGE_KEY.ETC_UID)}&plate_no=${this.currentOrder.plate_no || ''}&order_sn=${this.currentOrder.order_sn}`
            return 1
          } else { // 未选择办理方式进入
          }
        }
        // 无订单
        if (type === 'click') {
          if (userInfo.is_binded) {
            // 无卡无订单已绑定
            this.$router.replace('bindSuccess')
            return 1
          }
        }
      } catch (e) {
        console.log('goods address getUserOrderInfo catch', e)
        throw new Error('goods detail  getUserOrderInfo err' + e)
      } finally {
        console.log('goods address getUserOrderInfo finally')
        this.m_loadingClose()
      }
    },
    checkCanApply() {
      if (this.appChannel === 'pingankoudai') {
        this.m_showConfirm({
          content: '该渠道暂不支持办理，请打开微信，搜索“ETC助手”小程序，进入ETC助手办理。',
          noCancel: true,
          confirmBtn: '知道了'
        })
        return false
      } else {
        return true
      }
    },
    ...mapMutations([
      'setUserLocation',
      'setCurrentOrder',
      'setCurrentIssuer',
      'setCurrentCard',
      'setNewApplyInfo',
      'setApplyOrderInfo'
    ])
  },
  beforeRouteLeave(to, from, next) {
    console.log(11111)
    // this.appChannel === 'pingankoudai' && localStorage.setItem(ETC.LOCAL_STORAGE_KEY.HOME_RELOAD, '')
    next()
  },
  async mounted() {
    customData.loginPhone = localStorage.getItem(ETC.LOCAL_STORAGE_KEY.LOGIN_PHONE)
    if (customData.loginPhone) {
      this.formData.send_phone = customData.loginPhone
    }
    customData.isIOS = await this.m_isIOS()
    this.checkCanApply()
    if (this.appChannel === 'pingankoudai') {
      try {
        this.m_showLoading()
        // province freight_fee
        // if (!this.userLocation.latitude) {
        //   await this.getLocation()
        // }
        const {issuer, card, province} = await reconApply.getApplyGoodsDetail({
          // longitude: this.userLocation.longitude,
          // latitude: this.userLocation.latitude
        })
        this.setUserLocation({province})
        this.setCurrentCard(card)
        this.setCurrentIssuer(issuer)
        // 用户订单状态为空：第一次进入页面，查询用户相关信息
        if (this.userApplyStep === null) {
          this.getUserOrderInfo('auto')
        }
      } finally {
        this.m_loadingClose()
      }
    }
    // 获取存储的车牌号信息
    if (this.newApplyInfo.plateNos && this.newApplyInfo.plateNos.length) {
      this.plateNos = this.newApplyInfo.plateNos
    } else if (this.userLocation.province) { // PROVINCES
      this.plateNos[0] = PROVINCES[this.userLocation.province] || ''
    }
    this.cantChoosePlateC = this.plateNos.slice(0, 8).join('').length >= 7 && this.plateNos.join('').length
    this.choosedPlateColor = this.newApplyInfo.plate_color || ''
    this.$forceUpdate()
    if (this.newApplyInfo.send_phone) {
      this.formData = this.newApplyInfo
      if (!customData.lastPhone) customData.lastPhone = this.newApplyInfo.send_phone
      this.phoneInvalid = !APP.PHONE_REG.test(this.formData.send_phone)
      this.checkFormRule = 'getCode'
      this.checkForm()
    }
    let recommend = localStorage.getItem(ETC.LOCAL_STORAGE_KEY.ZHAO_HANG_RECOMMEND)
    recommend && (this.formData.referrer_code = recommend)
  },
  destroyed() {
    if (this.formData.send_name) {
      console.log('goods pay destroyed')
      let applyInfo = Object.assign({}, this.formData, {
        plate_no: this.plateNos.join(''),
        plateNos: this.plateNos,
        plate_color: this.choosedPlateColor
      })
      applyInfo.verification_code = void 0
      this.setNewApplyInfo(applyInfo)
    }
  }
}
</script>

<style scoped lang="scss">
@import "../../style/cool.practical";
.goods-address-page-wrap{
  background-color: #fff;
  @include routeViewMinH(130px);
  .title{
    padding: 40px 0 20px;
    @extend %flex-space-between;
    .label{
      /*padding-left: 24px;*/
      font-size: 36px;
      color: #333333;
      //@include title-before(4px, 40px);
    }
  }
  .form-item{
    height: 100px;
    font-size: 30px;
    color: #22262e;
    border-bottom: 1px solid $border-bottom-color;
    @extend %flex-align-center;
    /*padding: 10px 0;*/
    label{
      flex: 0 0 150px;
      margin-right: 10px;
      padding: 10px 0;
      box-sizing: content-box;
    }
    input, .value{
      font-size: 30px;
      padding: 20px 0;
      flex-grow: 1;
      height: 80px;
      /*line-height: 40px;*/
    }
    .value{
      @extend %flex-space-between;
      &.gray {
        color: $placeholder-color;
        font-size: $placeholder-size;
        line-height: $placeholder-line-height;
      }
    }
  }
  .tip{
    color: #999999;
    font-size: 24px;
    margin-top: 20px;
    line-height: 34px;
  }
  .plate-no-wrap{
    @extend %plate-no;
  }
  .plate-type-wrap{
    padding: 0 40px 50px;
    .plate-types{
      @extend %flex-align-center;
    }
    .plate-type{
      position: relative;
      font-size: 0;
      margin-right: 35px;
      img{
        width: 210px;
        height: 78px;
      }
      i{
        position: absolute;
        bottom: -10px;
        right: -10px;
        font-size: 36px;
        background-color: #fff;
        width: 40px;
        height: 40px;
        border-radius: 50%;
        /*border: 1px solid #fff;*/
        &:before{
          border: 1px solid #FFFFFF;
          border-radius: 50%;
        }
      }
    }
  }
  .owner-form{
    border-top: 20px solid #f5f5f5;
    border-bottom: 20px solid #f5f5f5;
    padding: 0 40px;
    .form-item{
      label {
        flex: 0 0 220px;
      }
    }
  }
  .address-wrap{
    border-top: 20px solid #f5f5f5;
    padding: 0 40px;
    .title{
      padding-bottom: 20px;
    }
    .address-form{
      position: relative;
      background-color: #fff;
      padding-bottom: 30px;
      .code-btn{
        width: 180px;
        height: 70px;
        border: none;
      }
      .form-err-tip{
        background-color: #fff;
        height:60px;
        word-wrap:break-word;
        word-break:break-all;
        font-size: 26px;
        position: absolute;
        // bottom: -20px;
        bottom: 0;
        @extend %flex-align-center;
        .etc-icon-warn {
          font-size: 26px;
          margin-right: 10px;
          top: 3px;
          position: relative;
        }
        .err-note {
          word-break: break-all;
          white-space: pre-wrap;
        }
        .link {
          color: #0094EE;
          text-decoration: underline;
        }
      }
    }
  }
  .agreement-box{
    padding-bottom: 20px;
    @extend %flex-center-start;
    .check-wrap{
      padding: 20px;
      margin-left: -20px;
      margin-top: -20px;
      align-self: flex-start;
      display: flex;
      .iconfont{
        font-size: 40px;
      }
      .etc-icon-uncheck{
        color: #cccccc;
      }
      .etc-icon-checked{
        color: $primary-color;
      }
    }
    .agreement{
      line-height: 40px;
      font-size: 26px;
      color: #333333;
      align-self: flex-start;
    }
  }
  .bottom-wrap{
    padding: 0 55px 30px;
  }
}
.toast-info-code {
  width: 640px;
  height: 500px;
  background: #FFFFFF;
  border-radius: 12px;
  padding: 0 28px 32px;
  .code-title {
    padding-top: 40px;
    width: 560px;
    height: 54px;
    font-size: 36px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #333333;
    line-height: 54px;
    text-align: center;
    margin-bottom: 48px;
  }
  .code-input {
    display: flex;
    justify-content: space-between;
    .input {
      width: 305px;
      height: 100px;
      background: #F5F6F7;
      border-radius: 4px;
      border: 1px solid #CCCCCC;
      box-sizing: border-box;
      padding: 20px;
    }
    .code-r {
      display: block;
      width: 259px;
      height: 100px;
      position: relative;
      img {
        width: 100%;
        height: 100%;
      }
      .tip {
        position: absolute;
        left: 50%;
        transform: translateX(-50%);
        bottom: -37px;
        font-size: 24px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #999999;
        line-height: 33px;
        white-space: nowrap;
      }
    }
  }
  .send-btn {
    margin-top: 64px;
  }
  .img-code-btn {
    width: 480px;
    height: 80px;
    background: linear-gradient(180deg, #0DE2A4 0%, #15C3C3 100%);
    border-radius: 45px;
    margin: 0 auto;
    line-height: 80px;
    text-align: center;

    font-size: 32px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #fff;
  }
  .cancel {
    margin-top: 40px;
    font-size: 28px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #666666;
    line-height: 42px;
    text-align: center;
  }
}
</style>
